import { motion } from 'framer-motion';
import clsx from 'clsx';

export function Logo({ size = 96, animated = true, className }: { size?: number; animated?: boolean; className?: string }) {
  return (
    <div
      className={clsx('relative grid place-items-center', className)}
      style={{ width: size, height: size }}
    >
      {animated && (
        <motion.div
          aria-hidden
          className="absolute inset-0 rounded-full"
          style={{
            background:
              'conic-gradient(from 0deg, rgba(124,92,255,0.6), rgba(34,211,238,0.4), rgba(124,92,255,0.6))',
            filter: 'blur(18px)',
          }}
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 12, ease: 'linear' }}
        />
      )}
      <div
        className="relative grid place-items-center rounded-full bg-gradient-to-br from-accent to-cyan shadow-glow"
        style={{ width: size * 0.72, height: size * 0.72 }}
      >
        <div
          className="rounded-full bg-bg-0"
          style={{ width: size * 0.34, height: size * 0.34 }}
        />
        <div
          className="absolute rounded-full bg-white"
          style={{ width: size * 0.12, height: size * 0.12 }}
        />
      </div>
    </div>
  );
}
